import { SIGN_UP_PROMPT_TYPE, USER_ACTIVITY_EVENTS } from 'utils/constant';

import { getCookie, setCookie } from '../utils';
import { logEventGTM } from '../utils/analyticsGTM';

import { logActivity } from './logActivity';

const sessionPopupService = {
  handleSessionTimerPopup: (
    user = {},
    enableSignUpPopupForUserSession,
    sessionTimerSignup,
    dispatchOpenSessionTimerSignupModal
  ) => {

    const urlPath = window.location.pathname;
    let sessionTimeForPopup3 = getCookie('_zippia-popup-s_t'); // _zippia-popup-s_t means session time which default time 1 minute
    let timeForPopup3 = 0;
    let timeIntervalForPopup3;
    const waitTimeForPopup3 = 240;

    const showSessionTimerPopup = urlPath !== '/resume-builder/' && urlPath !== '/job-tracker/signup/';

    const __addListener = (events) => {
      events.reduce((total, event) => {
        document.addEventListener(event, () => {
          if (
            !getCookie('_zippia-popup-s_f') &&
            !sessionTimerSignup.open &&
            showSessionTimerPopup
          ) {
            // timer include three case:survey popup ,login popup,show more popup
            // timer popup
            dispatchOpenSessionTimerSignupModal();

            setCookie({
              item: '_zippia-popup-s_f',
              value: 'true',
              expiredays: 1,
              path: '/',
            }); // _zippia-popup-s_f means session flag which occurs when this popup appears

            const gtmDataToLog = {
              event: 'signUpPrompt',
              signUpType: SIGN_UP_PROMPT_TYPE.POP_UP_SESSION_DURATION,
            };
            const activityDataToLog = {
              activityType: USER_ACTIVITY_EVENTS.SIGN_UP.SIGN_UP_POPUP,
              url: window.location.href,
              pageCategory: window.pageCategory,
              userId: user.userId || window.userId || '',
            };
            if (user.isLoggedIn) return;

            logEventGTM(gtmDataToLog);
            logActivity(activityDataToLog);
          }
        });
      }, []);
    };

    if (enableSignUpPopupForUserSession && !/\/employer\//.test(urlPath)) {
      if (user.isLoggedIn) return;

      var checkSession = setInterval(() => {
        if (getCookie('zippia.sid')) {
          clearInterval(checkSession);
          if (sessionTimeForPopup3 && parseInt(sessionTimeForPopup3) < waitTimeForPopup3) {
            timeIntervalForPopup3 = setInterval(() => {
              setCookie({
                item: '_zippia-popup-s_t',
                value: ++sessionTimeForPopup3,
                expiredays: 1,
                path: '/',
              });
              if (parseInt(sessionTimeForPopup3) == waitTimeForPopup3) {
                clearInterval(timeIntervalForPopup3);
                __addListener(['mousemove', 'scroll', 'keypress', 'resize', 'click']);
              }
            }, 1000);
          } else if (sessionTimeForPopup3 && parseInt(sessionTimeForPopup3) >= waitTimeForPopup3) {
            if (getCookie('_zippia-popup-s_f_i')) {
              // _zippia-popup-s_t means session flag indicate where in home survey
              // delete this flag which indicate when 1 minute but popup not appear
              setCookie({
                item: '_zippia-popup-s_f_i',
                value: null,
                expiredays: -1000,
                path: '/',
              });
            }
            __addListener(['mousemove', 'scroll', 'keypress', 'resize', 'click']);
          } else {
            setCookie({
              item: '_zippia-popup-s_t',
              value: 0,
              expiredays: 1,
              path: '/',
            });
            timeIntervalForPopup3 = setInterval(() => {
              setCookie({
                item: '_zippia-popup-s_t',
                value: ++timeForPopup3,
                expiredays: 1,
                path: '/',
              });
              if (timeForPopup3 === waitTimeForPopup3) {
                clearInterval(timeIntervalForPopup3);
                __addListener(['mousemove', 'scroll', 'keypress', 'resize', 'click']);
              }
            }, 1000);
          }
        }
      }, 50);
    }
  },

  sessionCondtitionalPopupHandler: (user) => {
    const sidCookiesName = 'zippia.sid';
    const triggeredSidCookiesName = '_zippia-popup-click-and-scroll-triggered-sid';

    // decode cookies before copying
    const sidCookies = getCookie(sidCookiesName);
    const triggeredSidCookies = getCookie(triggeredSidCookiesName);
    const sidCookiesDecoded = decodeURIComponent(sidCookies);
    const triggeredSidCookiesDecoded = decodeURIComponent(triggeredSidCookies);

    const minShowMoreClickTriggerCount = 1;
    const minJobCardScrollTriggerCount = (() => {
      if (window.innerWidth >= 1200) {
        return 8;
      }
      if (window.innerWidth >= 992) {
        return 6;
      }
      return 4;
    })();

    const isSessionValidToTrigger = () => sidCookiesDecoded !== triggeredSidCookiesDecoded;

    const isUserValidToTrigger = () => user && !user.isLoggedIn;

    const logData = (popupSrc) => {
      const gtmDataToLog = {
        event: 'signUpPrompt',
        signUpType: popupSrc,
      };

      const activityDataToLog = {
        activityType: 'SIGN_UP_POPUP',
        url: window.location.href,
        pageCategory: window.pageCategory,
        userId: user.userId || window.userId || '',
      };

      logEventGTM(gtmDataToLog);
      logActivity(activityDataToLog);
    };

    const jobCardScrolled = (scrolledCardCount) => {
      if (scrolledCardCount >= minJobCardScrollTriggerCount) {
        setCookie({
          item: triggeredSidCookiesName,
          value: sidCookiesDecoded,
          expiredays: 24 * 60,
          path: '/',
        });
        logData('popup-bucket-scroll');
        return true;
      }
      return false;
    };

    const isValidToTrigger = () => isSessionValidToTrigger() && isUserValidToTrigger();

    const showMoreClicked = (popupTriggerCounter) => {
      if (isValidToTrigger() && popupTriggerCounter >= minShowMoreClickTriggerCount) {
        setCookie({
          item: triggeredSidCookiesName,
          value: sidCookiesDecoded,
          expiredays: 24 * 60,
          path: '/',
        });
        logData('popup-show-more');
        return true;
      }
      return false;
    };

    return {
      jobCardScrolled,
      showMoreClicked,
      isValidToTrigger,
    };
  },
};

export { sessionPopupService };
